import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgNotFound = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: 177,
	height: 177,
	viewBox: "0 0 177 177",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [
		title ? /* @__PURE__ */ _jsx("title", {
			id: titleId,
			children: title
		}) : null,
		/* @__PURE__ */ _jsxs("g", {
			clipPath: "url(#clip0_3426_10892)",
			children: [
				/* @__PURE__ */ _jsx("path", {
					fillRule: "evenodd",
					clipRule: "evenodd",
					d: "M172.916 60.2425H167.978C166.831 60.242 165.892 61.1503 165.858 62.2929V62.4303C165.892 63.5728 166.831 64.4811 167.978 64.4806H170.097C170.855 64.4806 171.554 64.8835 171.933 65.5375C172.312 66.1915 172.312 66.9973 171.933 67.6513C171.554 68.3053 170.855 68.7082 170.097 68.7082H144.662C143.491 68.7082 142.542 67.7618 142.542 66.5944C142.542 65.427 143.491 64.4806 144.662 64.4806H147.841C148.987 64.4811 149.926 63.5728 149.961 62.4303V62.2929C149.926 61.1503 148.987 60.242 147.841 60.2425H142.542C141.371 60.2425 140.422 59.2962 140.422 58.1287C140.422 56.9613 141.371 56.015 142.542 56.015H154.105C154.672 56.0407 155.227 55.8381 155.643 55.4526C156.059 55.0671 156.303 54.531 156.32 53.9646V53.8272C156.301 53.2588 156.053 52.7221 155.632 52.3382C155.211 51.9544 154.653 51.7558 154.083 51.7874H153.119C151.948 51.7874 150.999 50.8411 150.999 49.6737C150.999 48.5063 151.948 47.5599 153.119 47.5599H167.511C153.532 20.7208 126.741 2.89268 96.5232 0.320219C66.3054 -2.25224 36.8721 10.7895 18.5329 34.8773H37.6096C38.7803 34.8773 39.7293 35.8236 39.7293 36.991C39.7293 38.1584 38.7803 39.1048 37.6096 39.1048H35.6278C35.0513 39.0642 34.4832 39.2602 34.055 39.6473C33.6268 40.0344 33.3757 40.579 33.3598 41.1552V41.2925C33.3785 41.8668 33.6309 42.4087 34.0587 42.7935C34.4866 43.1783 35.0531 43.3729 35.6278 43.3323H47.1374C48.308 43.3323 49.257 44.2787 49.257 45.4461C49.257 46.6135 48.308 47.5599 47.1374 47.5599H16.4027C15.2321 47.5599 14.2831 46.6135 14.2831 45.4461C14.2831 44.2787 15.2321 43.3323 16.4027 43.3323H16.2543C16.8308 43.3729 17.399 43.177 17.8271 42.7899C18.2553 42.4028 18.5064 41.8581 18.5224 41.282V41.1446C18.5038 40.5683 18.25 40.0247 17.8197 39.6396C17.3895 39.2544 16.8202 39.0613 16.2437 39.1048H15.4913C-7.5978 73.4493 -3.67907 119.176 24.9191 149.115C53.5172 179.055 99.1263 185.179 134.647 163.849C170.167 142.519 186.074 99.454 172.916 60.2425Z",
					fill: "#F7F7F7"
				}),
				/* @__PURE__ */ _jsx("path", {
					fillRule: "evenodd",
					clipRule: "evenodd",
					d: "M147.823 39.1048C144.332 39.5151 143.995 39.8508 143.584 43.3323C143.172 39.8508 142.836 39.5151 139.344 39.1048C142.836 38.6945 143.172 38.3588 143.584 34.8773C143.995 38.3588 144.332 38.6945 147.823 39.1048Z",
					fill: "#B8B9B9"
				}),
				/* @__PURE__ */ _jsx("path", {
					fillRule: "evenodd",
					clipRule: "evenodd",
					d: "M57.7335 23.2515C55.9879 23.4629 55.8258 23.6245 55.6138 25.3653C55.4018 23.6245 55.2397 23.4629 53.494 23.2515C55.2397 23.0401 55.4018 22.8785 55.6138 21.1377C55.8133 22.8785 55.9879 23.0401 57.7335 23.2515Z",
					fill: "#B8B9B9"
				}),
				/* @__PURE__ */ _jsx("path", {
					fillRule: "evenodd",
					clipRule: "evenodd",
					d: "M109.668 50.7305C107.922 50.9419 107.76 51.1036 107.548 52.8443C107.336 51.1036 107.174 50.9419 105.428 50.7305C107.174 50.5192 107.336 50.3575 107.548 48.6168C107.747 50.3575 107.922 50.5192 109.668 50.7305Z",
					fill: "#B8B9B9"
				}),
				/* @__PURE__ */ _jsx("path", {
					fillRule: "evenodd",
					clipRule: "evenodd",
					d: "M127.686 19.024C125.94 19.2353 125.778 19.397 125.566 21.1377C125.354 19.397 125.192 19.2353 123.446 19.024C125.192 18.8126 125.354 18.6509 125.566 16.9102C125.765 18.6509 125.94 18.8126 127.686 19.024Z",
					fill: "#B8B9B9"
				}),
				/* @__PURE__ */ _jsx("path", {
					fillRule: "evenodd",
					clipRule: "evenodd",
					d: "M157.362 79.2665C155.617 79.4778 155.454 79.6395 155.243 81.3802C155.031 79.6395 154.868 79.4778 153.123 79.2665C154.868 79.0551 155.031 78.8934 155.243 77.1527C155.442 78.8934 155.617 79.0551 157.362 79.2665Z",
					fill: "#B8B9B9"
				}),
				/* @__PURE__ */ _jsx("path", {
					fillRule: "evenodd",
					clipRule: "evenodd",
					d: "M28.0569 72.9251C24.5655 73.3355 24.2289 73.6712 23.8174 77.1527C23.4059 73.6712 23.0692 73.3355 19.5779 72.9251C23.0692 72.5148 23.4059 72.1791 23.8174 68.6976C24.2289 72.1791 24.5655 72.5148 28.0569 72.9251Z",
					fill: "#B8B9B9"
				}),
				/* @__PURE__ */ _jsx("path", {
					fillRule: "evenodd",
					clipRule: "evenodd",
					d: "M85.2904 8.45508C81.799 8.8654 81.4624 9.20112 81.0509 12.6826C80.6394 9.20112 80.3027 8.8654 76.8114 8.45508C80.3027 8.04476 80.6394 7.70905 81.0509 4.22754C81.4624 7.70905 81.799 8.04476 85.2904 8.45508Z",
					fill: "#B8B9B9"
				}),
				/* @__PURE__ */ _jsx("path", {
					opacity: .03,
					d: "M66.2126 155.362C66.2126 154.195 67.1546 153.249 68.3235 153.249H111.796C112.962 153.249 113.907 154.197 113.907 155.362C113.907 156.53 112.965 157.476 111.796 157.476H68.3235C67.1577 157.476 66.2126 156.527 66.2126 155.362Z",
					fill: "black"
				}),
				/* @__PURE__ */ _jsx("path", {
					fillRule: "evenodd",
					clipRule: "evenodd",
					d: "M88.1203 15.3249C80.5107 15.3249 74.3419 21.4763 74.3419 29.0644V31.1782C74.3413 34.2452 75.3753 37.2233 77.2777 39.6332H98.9629C100.865 37.2233 101.899 34.2452 101.899 31.1782V29.0644C101.899 25.4204 100.447 21.9257 97.8631 19.3491C95.2792 16.7724 91.7746 15.3249 88.1203 15.3249Z",
					fill: "#EBEBEB"
				}),
				/* @__PURE__ */ _jsx("path", {
					fillRule: "evenodd",
					clipRule: "evenodd",
					d: "M88.1203 15.3249C80.5107 15.3249 74.3419 21.4763 74.3419 29.0644V31.1782C74.3413 34.2452 75.3753 37.2233 77.2777 39.6332H98.9629C100.865 37.2233 101.899 34.2452 101.899 31.1782V29.0644C101.899 25.4204 100.447 21.9257 97.8631 19.3491C95.2792 16.7724 91.7746 15.3249 88.1203 15.3249Z",
					stroke: "#686868",
					strokeWidth: .5
				}),
				/* @__PURE__ */ _jsx("path", {
					fillRule: "evenodd",
					clipRule: "evenodd",
					d: "M100.881 26.9506H75.3487C73.2462 26.9534 71.2314 27.7911 69.7497 29.2786C68.2679 30.766 67.4414 32.7807 67.4526 34.8773V37.3821C67.4727 37.6449 67.6037 37.8869 67.813 38.0479C69.5724 36.5683 77.9878 35.448 88.1203 35.448C98.2528 35.448 106.668 36.5683 108.428 38.0479C108.637 37.8869 108.768 37.6449 108.788 37.3821V34.8773C108.799 32.7789 107.971 30.7626 106.487 29.2748C105.003 27.7871 102.986 26.9506 100.881 26.9506Z",
					fill: "#EBEBEB"
				}),
				/* @__PURE__ */ _jsx("path", {
					fillRule: "evenodd",
					clipRule: "evenodd",
					d: "M100.881 26.9506H75.3487C73.2462 26.9534 71.2314 27.7911 69.7497 29.2786C68.2679 30.766 67.4414 32.7807 67.4526 34.8773V37.3821C67.4727 37.6449 67.6037 37.8869 67.813 38.0479C69.5724 36.5683 77.9878 35.448 88.1203 35.448C98.2527 35.448 106.668 36.5683 108.428 38.0479C108.637 37.8869 108.768 37.6449 108.788 37.3821V34.8773C108.799 32.7789 107.971 30.7626 106.487 29.2748C105.003 27.7871 102.986 26.9506 100.881 26.9506Z",
					stroke: "#686868",
					strokeWidth: .5,
					strokeLinejoin: "round"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M75.1323 32.5464V30.8668C75.1323 30.4526 74.7965 30.1168 74.3823 30.1168H72.7116C72.2974 30.1168 71.9616 30.4526 71.9616 30.8668V32.5464C71.9616 32.9606 72.2974 33.2964 72.7116 33.2964H74.3823C74.7965 33.2964 75.1323 32.9606 75.1323 32.5464Z",
					fill: "#F1E48F",
					stroke: "#686868",
					strokeWidth: .25
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M82.5514 31.4895V29.8099C82.5514 29.3957 82.2156 29.0599 81.8014 29.0599H80.1308C79.7165 29.0599 79.3808 29.3957 79.3808 29.8099V31.4895C79.3808 31.9037 79.7165 32.2395 80.1308 32.2395H81.8014C82.2156 32.2395 82.5514 31.9037 82.5514 31.4895Z",
					fill: "#F1E48F",
					stroke: "#686868",
					strokeWidth: .25
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M89.9706 31.4895V29.8099C89.9706 29.3957 89.6348 29.0599 89.2206 29.0599H87.5499C87.1357 29.0599 86.7999 29.3957 86.7999 29.8099V31.4895C86.7999 31.9037 87.1357 32.2395 87.5499 32.2395H89.2206C89.6348 32.2395 89.9706 31.9037 89.9706 31.4895Z",
					fill: "#F1E48F",
					stroke: "#686868",
					strokeWidth: .25
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M97.3898 31.4895V29.8099C97.3898 29.3957 97.054 29.0599 96.6398 29.0599H94.9691C94.5549 29.0599 94.2191 29.3957 94.2191 29.8099V31.4895C94.2191 31.9037 94.5549 32.2395 94.9691 32.2395H96.6398C97.054 32.2395 97.3898 31.9037 97.3898 31.4895Z",
					fill: "#F1E48F",
					stroke: "#686868",
					strokeWidth: .25
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M104.809 32.5464V30.8668C104.809 30.4526 104.473 30.1168 104.059 30.1168H102.388C101.974 30.1168 101.638 30.4526 101.638 30.8668V32.5464C101.638 32.9606 101.974 33.2964 102.388 33.2964H104.059C104.473 33.2964 104.809 32.9606 104.809 32.5464Z",
					fill: "#F1E48F",
					stroke: "#686868",
					strokeWidth: .25
				}),
				/* @__PURE__ */ _jsx("path", {
					fillRule: "evenodd",
					clipRule: "evenodd",
					d: "M108.809 38.0479C108.809 39.4853 99.5564 40.6479 88.1309 40.6479C76.7054 40.6479 67.4526 39.443 67.4526 38.0479C67.4526 36.6528 76.7054 34.8033 88.1309 34.8033C99.5564 34.8033 108.809 36.5683 108.809 38.0479Z",
					fill: "#B8B9B9",
					stroke: "#686868",
					strokeWidth: .5
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M131.003 129.912L131.957 129.521L125.311 113.7L124.294 113.964L131.003 129.912Z",
					fill: "url(#paint0_linear_3426_10892)"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M42.7998 155.457L43.7855 155.796L51.5544 132.956L50.3462 133.263L42.7998 155.457Z",
					fill: "url(#paint1_linear_3426_10892)"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M93.5469 38.1959L93.3773 38.0479C91.8736 36.9431 90.0265 36.4041 88.1627 36.526C85.778 36.526 83.7112 37.1707 82.7679 38.217L82.6195 38.3755L50.3144 133.263L51.5226 132.946L83.5204 38.8829C84.2305 38.0902 86.0323 37.53 88.1415 37.53C89.765 37.4175 91.378 37.8653 92.7096 38.7983L124.326 113.964L125.386 113.7L93.6317 38.3967L93.5469 38.1959Z",
					fill: "url(#paint2_linear_3426_10892)"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M93.5469 38.1959L93.3773 38.0479C91.8736 36.9431 90.0265 36.4041 88.1627 36.526C85.778 36.526 83.7112 37.1707 82.7679 38.217L82.6195 38.3755L50.3144 133.263L51.5226 132.946L83.5204 38.8829C84.2305 38.0902 86.0323 37.53 88.1415 37.53C89.765 37.4175 91.378 37.8653 92.7096 38.7983L124.326 113.964L125.386 113.7L93.6317 38.3967L93.5469 38.1959Z",
					fill: "#686868"
				}),
				/* @__PURE__ */ _jsx("g", {
					opacity: .6,
					children: /* @__PURE__ */ _jsx("path", {
						fillRule: "evenodd",
						clipRule: "evenodd",
						d: "M93.0169 39.6333H92.964C92.9582 39.5319 92.9368 39.4321 92.9004 39.3373L92.805 39.1048C92.2856 38.1959 90.4202 37.5089 88.1839 37.5089C85.5448 37.5089 83.4038 38.4495 83.4038 39.6227H83.2978L42.3759 160.266L134.045 137.226L93.0169 39.6333Z",
						fill: "url(#paint3_linear_3426_10892)"
					})
				}),
				/* @__PURE__ */ _jsxs("g", {
					opacity: .5,
					children: [
						/* @__PURE__ */ _jsx("path", {
							d: "M68.3959 105.245L63.8596 119.196",
							stroke: "#E5BE60",
							strokeWidth: .25
						}),
						/* @__PURE__ */ _jsx("path", {
							d: "M94.416 56.7442L97.7122 66.2773",
							stroke: "#E5BE60",
							strokeWidth: .25
						}),
						/* @__PURE__ */ _jsx("path", {
							d: "M84.6863 44.4632L83.7112 48.6168",
							stroke: "#E5BE60",
							strokeWidth: .25
						}),
						/* @__PURE__ */ _jsx("path", {
							d: "M86.4987 65.4953L86.2549 73.3585",
							stroke: "#E5BE60",
							strokeWidth: .25
						}),
						/* @__PURE__ */ _jsx("path", {
							d: "M114.458 105.562L119.991 120.083",
							stroke: "#E5BE60",
							strokeWidth: .25
						}),
						/* @__PURE__ */ _jsx("path", {
							d: "M91.194 43.0576L92.381 46.5347",
							stroke: "#E5BE60",
							strokeWidth: .25
						}),
						/* @__PURE__ */ _jsx("path", {
							d: "M79.885 61.5108L77.7441 68.5814",
							stroke: "#E5BE60",
							strokeWidth: .25
						})
					]
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M108.608 113.14L110.176 110.032L113.356 102.75C113.801 101.524 112.826 99.7912 111.173 98.6392C105.496 95.1432 99.0645 93.0489 92.4128 92.5304C85.8276 91.8527 79.1758 92.7775 73.0276 95.2255C71.194 96.071 69.9222 97.6034 70.1447 98.8928L71.9465 106.619L72.9322 109.958L108.608 113.14Z",
					fill: "#B8B9B9",
					stroke: "#686868",
					strokeWidth: .5
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M72.1373 124.501L72.3705 130.134C72.3802 130.296 72.5061 130.426 72.6673 130.441L73.388 130.504C73.5551 130.518 73.7058 130.404 73.7377 130.24L74.8612 124.713C74.8796 124.622 74.8591 124.528 74.8047 124.454C74.7502 124.38 74.6669 124.332 74.575 124.322L72.4553 124.131C72.3621 124.134 72.2743 124.175 72.2137 124.246C72.153 124.316 72.1253 124.409 72.1373 124.501Z",
					fill: "#B8B9B9",
					stroke: "#686868",
					strokeWidth: .5
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M104.093 127.355L104.326 132.988C104.336 133.149 104.462 133.279 104.623 133.294L105.354 133.358C105.521 133.372 105.672 133.258 105.704 133.094L106.827 127.577C106.846 127.486 106.825 127.393 106.771 127.318C106.716 127.244 106.633 127.196 106.541 127.186L104.421 126.995C104.328 126.995 104.24 127.034 104.177 127.102C104.114 127.171 104.084 127.263 104.093 127.355Z",
					fill: "#B8B9B9",
					stroke: "#686868",
					strokeWidth: .5
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M97.5638 122.25L97.8288 127.429C97.8339 127.592 97.9623 127.724 98.1256 127.735L98.8675 127.799C99.0288 127.813 99.1749 127.703 99.2067 127.545L100.267 122.493C100.289 122.402 100.27 122.307 100.214 122.231C100.159 122.156 100.074 122.109 99.9804 122.102L97.8606 121.912C97.7762 121.917 97.6975 121.956 97.6418 122.019C97.5861 122.083 97.558 122.166 97.5638 122.25Z",
					fill: "#B8B9B9",
					stroke: "#686868",
					strokeWidth: .5
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M79.9168 120.305L80.203 125.822C80.2077 125.999 80.3443 126.144 80.521 126.161L81.2099 126.224C81.3891 126.244 81.5543 126.125 81.5915 125.949L82.7361 120.57L79.9168 120.305Z",
					fill: "#B8B9B9",
					stroke: "#686868",
					strokeWidth: .5
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M89.4558 126.382C93.2395 126.721 100.277 127.228 102.471 126.921C102.858 126.868 103.252 126.897 103.626 127.006C104.463 127.225 105.318 127.363 106.181 127.418C108.131 127.598 108.682 127.418 108.714 127.027C108.746 126.636 111.046 110.561 111.575 108.69C112.105 106.82 113.239 103.638 113.441 103.089C113.642 102.539 113.706 100.922 111.575 100.732C110.151 100.602 108.815 101.437 108.311 102.772C107.41 104.262 105.502 111.438 105.259 113.203L104.941 115.433C104.732 116.916 103.394 117.976 101.899 117.843L78.9311 115.803C77.4326 115.669 76.3037 114.385 76.3662 112.886L76.451 110.635C76.5252 108.849 75.9211 101.451 75.3064 99.8229C75.045 98.4039 73.8558 97.3397 72.4129 97.2335C70.2931 97.0433 70.0705 98.6498 70.1553 99.2205C70.2401 99.7912 70.8019 103.12 70.9926 105.065C71.1834 107.01 70.5687 123.265 70.5369 123.624C70.5051 123.983 71.0138 124.279 72.964 124.459C73.8189 124.558 74.6813 124.576 75.5395 124.512C75.9328 124.471 76.3301 124.515 76.7054 124.639C78.7722 125.315 85.3964 126.034 89.1696 126.361L89.4558 126.382Z",
					fill: "#EBEBEB",
					stroke: "#686868",
					strokeWidth: .5
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M103.001 118.255C103.001 118.255 99.7154 118.815 90.2825 117.98C80.8495 117.145 77.7653 116.004 77.7653 116.004C76.8365 115.899 76.1629 115.072 76.2496 114.144L76.6206 110.011C76.7102 109.077 77.5375 108.389 78.4754 108.468C82.7157 108.233 86.9679 108.325 91.194 108.743C95.4101 109.088 99.5943 109.749 103.711 110.719C104.648 110.809 105.338 111.634 105.259 112.569L104.888 116.701C104.847 117.158 104.625 117.58 104.271 117.872C103.916 118.164 103.459 118.302 103.001 118.255Z",
					fill: "#EBEBEB",
					stroke: "#686868",
					strokeWidth: .5
				}),
				/* @__PURE__ */ _jsxs("g", {
					opacity: .3,
					children: [/* @__PURE__ */ _jsx("path", {
						d: "M104.58 133.834C104.155 133.792 103.826 133.445 103.807 133.02L103.584 127.566H103.478C103.272 127.504 103.057 127.472 102.842 127.471H102.545C101.863 127.547 101.176 127.579 100.489 127.566H99.7578V127.682C99.673 128.076 99.3244 128.358 98.9205 128.359L98.1044 128.285C97.6869 128.245 97.3598 127.909 97.3307 127.492C94.0026 127.344 90.4732 127.038 89.424 126.943H89.1484C87.9719 126.837 85.0148 126.562 82.1002 126.182C81.9844 126.552 81.6411 126.804 81.2523 126.805L80.4892 126.742C80.0504 126.701 79.7079 126.346 79.6837 125.907V125.769C78.631 125.628 77.5898 125.413 76.5676 125.125C76.3387 125.048 76.0989 125.009 75.8575 125.009H75.6137H75.3593L74.2995 130.293C74.219 130.691 73.8693 130.978 73.4622 130.98L72.6566 130.916C72.2275 130.88 71.892 130.532 71.8723 130.103L71.6498 124.765C70.9078 124.639 69.9645 124.343 70.0387 123.529C70.0387 123.402 70.6747 106.999 70.4945 105.076C70.3355 103.395 69.8904 100.637 69.7208 99.601L69.636 99.3473C69.6254 99.2207 69.6254 99.0934 69.636 98.9668C69.424 97.4555 70.6959 95.7962 72.8156 94.7393C77.7605 92.7218 83.0644 91.7259 88.4065 91.8117C89.7525 91.8117 91.1198 91.8751 92.4658 91.9914C99.2165 92.4983 105.744 94.6269 111.491 98.1953C112.813 99.0165 113.72 100.363 113.981 101.894C114.109 102.34 114.109 102.812 113.981 103.258L113.865 103.575C113.515 104.568 112.582 107.2 112.127 108.859C111.671 110.519 109.36 126.298 109.286 127.101C109.212 127.904 107.919 128.031 107.421 128.031H107.325L106.265 133.231C106.185 133.629 105.835 133.916 105.428 133.918L104.58 133.834Z",
						fill: "#F1E48F"
					}), /* @__PURE__ */ _jsx("path", {
						d: "M88.3959 92.3507C89.6783 92.3507 91.0244 92.4036 92.4128 92.5304C99.0645 93.0489 105.496 95.1432 111.173 98.6392C112.381 99.3766 113.211 100.598 113.451 101.99C113.55 102.335 113.55 102.701 113.451 103.046C113.261 103.596 112.116 106.777 111.586 108.648C111.056 110.519 108.756 126.615 108.724 126.985C108.693 127.355 108.375 127.439 107.378 127.439H106.827C106.834 127.478 106.834 127.517 106.827 127.556L105.704 133.073C105.674 133.224 105.541 133.335 105.386 133.337L104.654 133.273C104.493 133.258 104.367 133.128 104.358 132.967L104.124 127.334C104.122 127.261 104.145 127.191 104.188 127.133L103.648 126.995C103.393 126.92 103.129 126.88 102.863 126.879H102.492C101.834 126.952 101.172 126.983 100.51 126.974H99.3232L99.2066 127.513C99.176 127.663 99.0422 127.77 98.8887 127.767L98.1468 127.704C97.9835 127.693 97.8551 127.56 97.85 127.397V126.921C95.0307 126.805 91.7027 126.552 89.4875 126.351H89.212C87.1558 126.171 84.2517 125.875 81.708 125.526L81.6232 125.928C81.5877 126.091 81.441 126.207 81.2735 126.203L80.5846 126.139C80.4079 126.123 80.2712 125.978 80.2666 125.801V125.304C79.0963 125.153 77.9382 124.92 76.8008 124.607C76.5202 124.516 76.2268 124.469 75.9317 124.469H75.6349H74.9354C74.9549 124.531 74.9549 124.598 74.9354 124.66L73.8119 130.177C73.7819 130.329 73.6492 130.439 73.494 130.441L72.7732 130.377C72.6121 130.362 72.4862 130.232 72.4765 130.071L72.2433 124.438C72.235 124.396 72.235 124.353 72.2433 124.311C70.9608 124.131 70.5899 123.867 70.6111 123.571C70.6323 123.275 71.247 106.957 71.0668 105.012C70.8867 103.068 70.3249 99.7278 70.2295 99.1676C70.2188 99.0587 70.2188 98.949 70.2295 98.84C70.0069 97.5612 71.2894 96.0181 73.1124 95.1726C77.9912 93.2006 83.2168 92.2231 88.4807 92.2979L88.3959 92.3507ZM88.4807 91.241C83.0267 91.1587 77.6133 92.1873 72.5719 94.2637C70.2719 95.3206 68.8411 97.2335 69.0743 98.9563C69.0622 99.1005 69.0622 99.2454 69.0743 99.3896L69.1272 99.7384C69.2968 100.795 69.742 103.511 69.8904 105.171C70.0387 106.83 69.4876 122.747 69.4346 123.539C69.3392 124.596 70.2507 125.03 71.0668 125.241L71.2682 130.177C71.2995 130.885 71.8622 131.455 72.5719 131.498L73.2926 131.561H73.4198C74.0629 131.565 74.6242 131.127 74.7764 130.504L75.7515 125.558H75.8151C75.9986 125.558 76.1811 125.586 76.3556 125.643C77.2834 125.913 78.229 126.118 79.1855 126.256C79.3642 126.789 79.8426 127.167 80.4044 127.217L81.0827 127.281H81.2099C81.6625 127.28 82.0877 127.064 82.3546 126.7C85.1632 127.059 87.9295 127.313 89.053 127.418H89.3286C90.3355 127.503 93.6423 127.788 96.8643 127.947C97.068 128.402 97.5011 128.712 97.9984 128.76L98.7403 128.824H98.8675C99.3965 128.82 99.8774 128.517 100.108 128.042H100.447C101.155 128.051 101.863 128.016 102.566 127.936H103.022L103.234 132.988C103.263 133.681 103.802 134.246 104.495 134.309L105.227 134.373H105.428C106.071 134.376 106.633 133.939 106.785 133.316L107.76 128.539C109.042 128.465 109.731 127.999 109.816 127.133C109.901 126.266 112.158 110.698 112.646 108.986C113.133 107.274 114.024 104.759 114.374 103.776L114.49 103.437C114.662 102.911 114.684 102.348 114.554 101.81C114.249 100.133 113.243 98.6649 111.787 97.7726C105.969 94.1373 99.3539 91.9614 92.5082 91.4312C91.141 91.3044 89.7631 91.2516 88.3959 91.2516L88.4807 91.241Z",
						fill: "#F1E48F"
					})]
				})
			]
		}),
		/* @__PURE__ */ _jsxs("defs", { children: [
			/* @__PURE__ */ _jsxs("linearGradient", {
				id: "paint0_linear_3426_10892",
				x1: 163.51,
				y1: 93.619,
				x2: 1339.44,
				y2: 723.582,
				gradientUnits: "userSpaceOnUse",
				children: [/* @__PURE__ */ _jsx("stop", {
					offset: .18,
					stopColor: "#686868"
				}), /* @__PURE__ */ _jsx("stop", {
					offset: .81,
					stopColor: "#686868",
					stopOpacity: 0
				})]
			}),
			/* @__PURE__ */ _jsxs("linearGradient", {
				id: "paint1_linear_3426_10892",
				x1: 841.95,
				y1: 174.175,
				x2: -602.827,
				y2: 811.027,
				gradientUnits: "userSpaceOnUse",
				children: [/* @__PURE__ */ _jsx("stop", {
					offset: .02,
					stopColor: "#686868"
				}), /* @__PURE__ */ _jsx("stop", {
					offset: .85,
					stopColor: "#686868",
					stopOpacity: 0
				})]
			}),
			/* @__PURE__ */ _jsxs("linearGradient", {
				id: "paint2_linear_3426_10892",
				x1: -701.141,
				y1: 4875.57,
				x2: 8214.57,
				y2: 4875.57,
				gradientUnits: "userSpaceOnUse",
				children: [
					/* @__PURE__ */ _jsx("stop", {
						offset: .04,
						stopColor: "#686868",
						stopOpacity: 0
					}),
					/* @__PURE__ */ _jsx("stop", {
						offset: .18,
						stopColor: "#686868"
					}),
					/* @__PURE__ */ _jsx("stop", {
						offset: .82,
						stopColor: "#686868"
					}),
					/* @__PURE__ */ _jsx("stop", {
						offset: .97,
						stopColor: "#686868",
						stopOpacity: 0
					})
				]
			}),
			/* @__PURE__ */ _jsxs("linearGradient", {
				id: "paint3_linear_3426_10892",
				x1: 4533.09,
				y1: 10809.3,
				x2: 3922.82,
				y2: 9543.03,
				gradientUnits: "userSpaceOnUse",
				children: [/* @__PURE__ */ _jsx("stop", {
					stopColor: "#F6EF76",
					stopOpacity: 0
				}), /* @__PURE__ */ _jsx("stop", {
					offset: 1,
					stopColor: "#F6EF76"
				})]
			}),
			/* @__PURE__ */ _jsx("clipPath", {
				id: "clip0_3426_10892",
				children: /* @__PURE__ */ _jsx("rect", {
					width: 177,
					height: 176.5,
					fill: "white",
					transform: "translate(0.5)"
				})
			})
		] })
	]
});
const ForwardRef = forwardRef(SvgNotFound);
export default ForwardRef;
